// extracted by mini-css-extract-plugin
module.exports = {"icon":"Checkbox_icon__1XLxv","iconEmpty":"Checkbox_iconEmpty__3bCQ3","iconChecked":"Checkbox_iconChecked__3wb7U","iconInvisible":"Checkbox_iconInvisible__3WbU4"};